import React, { useMemo } from 'react';
import { createEditor, Descendant } from 'slate';
import { Editable, Slate, withReact, ReactEditor } from 'slate-react';
import { createInitialValue } from './richText';
import { renderElement, renderLeaf } from './richTextRenderersUtils';

type Props = {
  value: Descendant[] | undefined;
  className: string;
};

const RichTextRenderer: React.FC<Props> = ({ value, className = '' }) => {
  const editor = useMemo(() => withReact(createEditor() as ReactEditor), []);
  const safeValue =
    value && Array.isArray(value) && value.length > 0
      ? value
      : createInitialValue();

  return (
    <Slate
      editor={editor}
      initialValue={safeValue}
      onChange={() => {
        /* read-only */
      }}
      key={JSON.stringify(safeValue)}
    >
      <Editable
        readOnly
        renderElement={renderElement}
        renderLeaf={renderLeaf}
        className={className}
      />
    </Slate>
  );
};

export default RichTextRenderer;
